import type { InputSource } from '../input/input-contract';
import type { PauseReason } from '../runtime/pause-controller';
import { translate, type Locale, type ResourceKey } from './resources';

const PAUSE_REASON_KEYS: Readonly<Record<PauseReason, ResourceKey>> = {
  user: 'pause.reason.user',
  'focus-loss': 'pause.reason.focusLoss',
  'visibility-hidden': 'pause.reason.visibilityHidden',
};

const INPUT_SOURCE_KEYS: Readonly<Record<InputSource, ResourceKey>> = {
  keyboard: 'input.source.keyboard',
  controller: 'input.source.controller',
  touch: 'input.source.touch',
};

export const formatPauseReasons = (
  locale: Locale,
  reasons: readonly PauseReason[],
): readonly string[] => reasons.map((reason) => translate(locale, PAUSE_REASON_KEYS[reason]));

export const formatPauseAnnouncement = (
  locale: Locale,
  reasons: readonly PauseReason[],
): string => translate(locale, 'status.paused', { reasons: formatPauseReasons(locale, reasons).join(', ') });

export const formatInputSources = (
  locale: Locale,
  sources: readonly InputSource[],
): string => sources.map((source) => translate(locale, INPUT_SOURCE_KEYS[source])).join(' + ');
